import ScoringWizardStepThree, { validator } from './ScoringWizardStepThree'

export { validator }
export default ScoringWizardStepThree
